export enum BusinessDocumentType {
  BVN = "bvn",
  NIN = "nin",
  VNIN = "vnin",
  PASSPORT = "passport",
  PVC = "pvc",
  TIN = "tin",
  CAC = "cac",
  NDL = "ndl",
}

export enum SupportedVerificationType {
  NIN = "nin",
  CAC = "cac",
}

export enum BusinessStatus {
  VERIFIED = "verified",
  PENDING = "pending",
}

export enum DocumentStatus {
  UPLOADED = "uploaded",
  REJECTED = "rejected",
  VERIFIED = "verified",
}

export enum AdminReviewStatus {
  PENDING = "pending",
  APPROVED = "approved",
  REJECTED = "rejected",
}

export interface ApiResponse<T = unknown> {
  status: string;
  message: string;
  data: T;
}

export interface PaginatedMetadata {
  currentPage: number;
  pageSize: number;
  totalPages: number;
  totalCount: number;
}

export interface Address {
  state?: string;
  city?: string;
  street?: string;
  country?: string;
}

export interface BusinessOwner {
  id: string;
  first_name: string;
  last_name: string;
  email: string;
  phone?: string;
  date_of_birth?: string;
  address?: Address;
  documents?: BusinessDocument[];
}

export interface BusinessDocument {
  id: string;
  type: BusinessDocumentType;
  status: DocumentStatus;
  admin_review_status: AdminReviewStatus;
  rejection_reason?: string | null;
  identification_number: string;
  upload_url?: string;
  created_at: string;
  updated_at: string;
}

export interface Business {
  id: string;
  name: string;
  email?: string;
  address: string;
  city?: string;
  state?: string;
  status?: BusinessStatus | null;
  credentials_link?: string[];
  owner?: BusinessOwner | null;
  documents?: BusinessDocument[];
  created_at: string;
  updated_at: string;
}

export interface UpdateBusinessInfoPayload {
  name?: string;
  address?: string;
  state?: string;
  city?: string;
}

export interface AddBusinessDocumentPayload {
  type: BusinessDocumentType;
  number: string;
  upload_url?: string;
}

export interface EditBusinessDocumentPayload {
  type?: BusinessDocumentType;
  number?: string;
  upload_url?: string;
}

export interface BusinessInfoResponse extends ApiResponse<
  Omit<Business, "documents"> & { documents: BusinessDocument[] }
> {}

export interface BusinessDocumentsResponse extends ApiResponse<
  BusinessDocument[]
> {}

export interface BusinessDocumentResponse extends ApiResponse<BusinessDocument> {}

export interface BusinessDocumentMutationResponse extends ApiResponse<BusinessDocument> {}
